import { render, staticRenderFns } from "./resetNewPwd.vue?vue&type=template&id=335ecd32&scoped=true"
import script from "./resetNewPwd.vue?vue&type=script&lang=js"
export * from "./resetNewPwd.vue?vue&type=script&lang=js"
import style0 from "./resetNewPwd.vue?vue&type=style&index=0&id=335ecd32&lang=less&scoped=true"
import style1 from "./resetNewPwd.vue?vue&type=style&index=1&id=335ecd32&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ecd32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335ecd32')) {
      api.createRecord('335ecd32', component.options)
    } else {
      api.reload('335ecd32', component.options)
    }
    module.hot.accept("./resetNewPwd.vue?vue&type=template&id=335ecd32&scoped=true", function () {
      api.rerender('335ecd32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/resetNewPwd.vue"
export default component.exports